import React from 'react';
import NewNavbar from './NewNavbar';
import './PolicyHero.css';

function PolicyHero({ title, pageName, heroImage, bgPosition, mobileHeroImage }) {
  return (
    <section
      className="ph-hero"
      style={{
        backgroundImage: `url(${heroImage})`,
        ...(bgPosition ? { backgroundPosition: bgPosition } : {}),
        ...(mobileHeroImage ? { '--ph-hero-mobile-bg': `url(${mobileHeroImage})` } : {}),
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-12">
            <NewNavbar />
          </div>
        </div>
      </div>
      <div className="ph-hero__body">
        <div className="ph-hero__content">
          <h1 className="ph-hero__title">{title}</h1>
          <nav className="ph-hero__breadcrumb" aria-label="Breadcrumb">
            <a href="/" className="ph-hero__bc-home">Home</a>
            <span className="ph-hero__bc-sep" aria-hidden="true">•</span>
            <span className="ph-hero__bc-current">{pageName}</span>
          </nav>
        </div>
      </div>
    </section>
  );
}

export default PolicyHero;
